export default function reducer(state = {
  datosReportesProconsumo: undefined
}, action) {
  switch (action.type) {
    case "SAVE_DATOS_REPORTES_PROCONSUMO": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}